import type { Nullable } from '@iheartjane/types';
import compact from 'lodash-es/compact';

import type { FilterSortOption } from '@jane/search/data-access';

import {
  productSortAlphabetically,
  productSortByDefault,
  productSortByHighestPrice,
  productSortByHighestThc,
  productSortByLowestPrice,
  productSortByLowestThc,
  productSortByRating,
  productSortByRecommended,
} from './productSort';

export const makeDefaultWithCustomLabel = (
  defaultSortName: Nullable<string>
): Nullable<FilterSortOption> => {
  return defaultSortName
    ? { ...productSortByDefault, label: defaultSortName }
    : null;
};

interface MakeSortOptionsArgs {
  defaultOption: Nullable<FilterSortOption>;
  hasOptionalFilters: boolean;
  showAlphabeticalSort: boolean;
  showThcOptions: boolean;
}

export const makeSortOptions = ({
  defaultOption = null,
  hasOptionalFilters,
  showAlphabeticalSort,
  showThcOptions,
}: MakeSortOptionsArgs): FilterSortOption[] => {
  return compact([
    productSortByRecommended,
    defaultOption,
    showAlphabeticalSort && !hasOptionalFilters && productSortAlphabetically,
    productSortByRating,
    productSortByLowestPrice,
    productSortByHighestPrice,
    showThcOptions && productSortByLowestThc,
    showThcOptions && productSortByHighestThc,
  ]);
};
